import { React, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

const TrustedItem = ({ Tr, handleNavigation }) => {
    const [logoError, setLogoError] = useState(false);

    return (
        <Box
            className="item-carosel"
            style={{padding : '0',background:Tr?.logo_bg_color ?? ''}}
            key={Tr.id}
            onClick={() => handleNavigation(Tr.uuid)}
        >
            {Tr?.logo && !logoError ? (
                <img
                    src={Tr.logo}
                    alt="panel"
                    style={{ width: "fit-content" ,maxWidth:100,margin:'0 20px',objectFit:'contain'}}
                    onError={() => setLogoError(true)}
                />
            ) : (
                <div className="final-logo-container" style={{alignContent:'center',minHeight:'85px',margin:'0 40px'}}>
                    <Typography
                        sx={{
                            fontSize: `${Tr?.customLogo?.fontSize}px`,
                            color: Tr?.customLogo?.color,
                            fontFamily: Tr?.customLogo?.fontFamily,
                        }}
                        className="final-logo"
                    >
                        {Tr?.customLogo?.logoName || "LOREM"}
                    </Typography>
                </div>
            )}
        </Box>
    );
};

const TrustedPanel = ({ trusted }) => {
    const navigate = useNavigate();

    const handleNavigation = (uuid) => {
        window.open(`${window.location.origin}/AdsPanelsDetails/${uuid}`, '_blank', 'noopener,noreferrer');
        // navigate(`/AdsPanelsDetails/${uuid}`);
    };

    if (!trusted?.length) return null;

    return (
        <Box sx={{ marginBlock: "40px" }}>
            <Typography
                sx={{
                    fontWeight: "700",
                    lineHeight: "40px",
                    fontSize: "40px",
                    color: "#4ea27d",
                    textAlign: "center",
                }}
            >
                Our Trusted Providers
            </Typography>

            <Box
                className="carousel"
                sx={{ marginTop: "60px" }}
                onMouseEnter={() => {
                    document.querySelector(".carousel-inner").style.animationPlayState = "paused";
                }}
                onMouseLeave={() => {
                    document.querySelector(".carousel-inner").style.animationPlayState = "running";
                }}
            >
                <Box className="carousel-inner">
                    {/* Original items */}
                    {trusted.map((Tr) => (
                        <TrustedItem key={Tr.id} Tr={Tr} handleNavigation={handleNavigation} />
                    ))}

                    {/* Duplicated items for infinite scroll effect */}
                    {trusted.map((Tr) => (
                        <TrustedItem key={`repeat-${Tr.id}`} Tr={Tr} handleNavigation={handleNavigation} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default TrustedPanel;